<div class="modal-header">
	<h4 class="modal-title">Daten synchronisieren</h4>
</div>
<div class="modal-body">
	@if (syncList.length === 0 && isSyncing) {
		<div class="d-flex align-items-center justify-content-center py-3">
			<span class="spinner-border spinner-border-sm me-2"></span>
			<span class="text-muted">Synchronisation wird vorbereitet...</span>
		</div>
	} @else if (syncList.length === 0) {
		<p class="text-muted">Keine Punktdaten zu synchronisieren.</p>
	} @else {
		@for (item of syncList; track item.projectId) {
			<div class="mb-3">
				<div class="d-flex justify-content-between align-items-center mb-1">
					<span class="fw-bold">
						<i class="bi me-2" [class]="getStatusIcon(item.status)"></i>
						{{ item.projectName }}
					</span>
					<small class="text-muted">
						@if (item.status === 'syncing' && item.docsTotal) {
							{{ item.docsWritten ?? 0 }} / {{ item.docsTotal }}
						}
						@if (item.status === 'done') {
							Fertig
						}
						@if (item.status === 'error') {
							Fehler
						}
					</small>
				</div>
				<ngb-progressbar
					[type]="getProgressType(item.status)"
					[value]="item.progress"
					[striped]="item.status === 'syncing'"
					[animated]="item.status === 'syncing'">
				</ngb-progressbar>
			</div>
		}
	}
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-primary"
			[disabled]="isSyncing"
			(click)="onClose()">
		@if (isSyncing) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>
			Synchronisiere...
		} @else {
			Schließen
		}
	</button>
</div>
